import React from "react";

import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/scss";

import useMediaQuery from "../../hooks/haiku/useMediaQuery";

import "./learnEmbedModule.scss";

const LearnEmbedModule = ({
  headline,
  children,
  buttonLearnArea,
  buttonDonorArea,
  subHeadlineDonorArea,
}) => {
  const swiperProps = {
    breakpoints: {
      0: {
        allowTouchMove: true,
        slidesPerView: "auto",
      },
      576: {
        allowTouchMove: true,
        slidesPerView: 2,
      },
    },
    focusableElements: "input, select, option, textarea, video, label",
    keyboard: true,
    modules: [Pagination],
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      bulletActiveClass: "active",
      bulletClass: "swiper-bullet-pagination",
      clickable: true,
      renderBullet: (index, name) => `<div class="${name}"></div>`,
    },
    spaceBetween: 30,
  };

  const isGreaterEqualLg = useMediaQuery("(min-width: 992px)", false);

  return (
    <div className="container--fullwidth learn-module">
      <Container fluid>
        <h3>{headline}</h3>
        <div className="learn-module__content">
          {isGreaterEqualLg
            ? (
              <Row>
                {React.Children.map(children, (child) => (
                  <Col lg={4} className="learn-module__content-item">{child}</Col>
                ))}
              </Row>
            )
            : (
              <Swiper
                {...swiperProps}
              >
                {React.Children.map(children, (child) => (
                  <SwiperSlide key={child.key}>
                    <div className="learn-module__content-item">{child}</div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
        </div>
        <div className="learn-module__button-container">
          <div className="align-self-sm-center">
            {buttonLearnArea}
          </div>
          <div className="learn-module__donor-button">
            <div className="typo-small-label">{subHeadlineDonorArea}</div>
            {buttonDonorArea}
          </div>
        </div>
      </Container>
    </div>
  );
};

LearnEmbedModule.propTypes = {
  buttonDonorArea: PropTypes.node.isRequired,
  buttonLearnArea: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  headline: PropTypes.string.isRequired,
  subHeadlineDonorArea: PropTypes.string.isRequired,
};

export default LearnEmbedModule;
